import { uniq } from 'utils/ObjectUtils';

export const clear = () => [];

export const addAll = (state, { payload }) => {
  // We 'sort' existing conversations using the payload
  // Then we concatenate with the other conversations stored
  // Finally append new ones.
  // Example :
  // - We have conversation "a, b, c"
  // - We get "b, c, d, e, f" from the backend (from `unread` call) :
  //   |- We first store "b, c" (=> existingConversations)
  //   |- Then "a" (thanks to `uniq` which will ignore "b, c") (=> state)
  //   |- Then "d, e, f" (=> newConversations)
  const root = payload?.conversations?.content ?? payload?.content;
  const { newConversations, existingConversations } = root.reduce(
    (acc, conversation) => {
      if (state.includes(conversation.id)) {
        acc.existingConversations.push(conversation.id);
      } else {
        acc.newConversations.push(conversation.id);
      }

      return acc;
    },
    { newConversations: [], existingConversations: [] }
  );
  return uniq([...state, ...existingConversations, ...newConversations]);
};

export const prependOneAfterSend = (state, { payload }) => {
  const newState = [...state];
  const conversationId = payload.conversationId ?? payload.id;

  const index = state.indexOf(conversationId);
  if (index > -1) {
    const [conversation] = newState.splice(index, 1);
    newState.unshift(conversation);
  }

  return newState;
};
